import { useNavigate } from 'react-router-dom';
import { RegisterForm } from '../components';
import { Card, Button } from '../components/common';
import './RegisterPage.css';

const RegisterPage = () => {
  const navigate = useNavigate();

  const handleRegistrationSuccess = () => {
    window.location.href = '/login';
  };

  return (
    <div className="register-page">
      <Card className="register-card" padding="lg">
        <Card.Header className="register-header">
          <Card.Title as="h1" className="register-title">회원가입</Card.Title>
        </Card.Header>
        
        <Card.Content>
          <RegisterForm onSuccess={handleRegistrationSuccess} />
        </Card.Content>
        
        <Card.Footer className="register-footer">
          <p className="login-link">
            이미 계정이 있으시나요? 
            <Button 
              onClick={() => navigate('/login')}
              variant="primary"
              size="sm"
              className="login-button"
            >
              로그인
            </Button>
          </p>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default RegisterPage;